import formatDate from "date-fns/format";
import t from "common/i18n";
import { SMD_DISPLAY_FORMAT } from "common/metadataDeps";

const isMultipleRules = (validation) => Array.isArray(validation.rules);

const extractValidationRules = (validation) => {
	return validation ?
		(isMultipleRules(validation) ? validation.rules : [validation]) :
		[];
};

const getRuleType = (rule) => {
	let type = rule.type;

	if (rule.equals) {
		type = `${rule.type}Equal`;
	}

	if (rule.type === "strlen") {
		if (Number.isInteger(rule.min) && Number.isInteger(rule.max)) {
			type = "minAndMax";
		} else if (Number.isInteger(rule.min)) {
			type = "min";
		} else {
			type = "max";
		}
	}

	return type;
};

const updateMessageValuesForDateField = (values, rule) => {
	let originalValue = values.originalValue,
		max = values.max,
		min = values.min;

	try {
		if (values.value) {
			originalValue = formatDate(values.value, SMD_DISPLAY_FORMAT);
		}

		if (rule.type.startsWith("lessThan")) {
			max = formatDate(new Date(rule.value), SMD_DISPLAY_FORMAT);
		}

		if (rule.type.startsWith("greaterThan")) {
			min = formatDate(new Date(rule.value), SMD_DISPLAY_FORMAT);
		}
	}
		// eslint-disable-next-line no-empty
	catch (e) {
	}

	return {
		...values,
		originalValue,
		max,
		min
	};
};

/**
 * get error message according to rule type and payload received from
 * formik&yup validationScheme.
 * @param fieldType
 * @param rule
 * @returns {function(*): *} => error msg with original rule config
 */
const errorMessageForRule = (fieldType, rule) => (values) => {
	if (fieldType === "date") {
		values = updateMessageValuesForDateField(values, rule);
	}

	const ruleType = getRuleType(rule);
	return t(`metadataPage.validationErrors.${fieldType}.${ruleType}`, { ...rule, ...values });
};

const errorMessagesForField = (field) => {
	return {
		required: t("metadataPage.validationErrors.required"),
		typeError: t(`metadataPage.validationErrors.${field.type}Error`),
		digitsLimitError: t("metadataPage.validationErrors.digitsLimitError"),
		integerTypeError: t("metadataPage.validationErrors.integerTypeError"),
	};
};

export default (fields) => {
	return fields.map((field) => {
		const rules = extractValidationRules(field.validation);

		return {
			...field,
			errorMessages: errorMessagesForField(field),
			validation: {
				type: "and",
				rules: rules.map((rule) =>
					({ ...rule, message: errorMessageForRule(field.type, rule) })),
			},
		};
	});
};

